import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/material";
import useStore from "../store";
import TabBackground from "../Main/Dashboard/TabBackground";

export default function InactiveOverlay() {
    const wakeUp = useStore((store) => store.app.wakeUp);
    const darkMode = useStore((store) => store.app.darkMode);
    const setInactive = useStore((store) => store.app.setInactive);
    const systemIdleTime = useStore((store) => store.app.systemIdleTime);
    const [countDown, setCountDown] = React.useState(10);
    React.useEffect(() => {
        const interval = setInterval(() => {
            setCountDown((prevState) => (prevState > 0 ? prevState - 1 : 0));
        }, 1000);
        if (countDown === 0) {
            setInactive();
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [countDown]);
    return (
        <>
            <TabBackground />
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div
                onClick={(e) => e.preventDefault()}
                style={{
                    position: "fixed",
                    display: "block",
                    width: "100%",
                    height: "100%",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    zIndex: "9999",
                    cursor: "pointer",
                }}
                onMouseMove={wakeUp}
            />
            <div
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    fontSize: "75px",
                    fontWeight: "bold",
                    zIndex: "9999",
                    color: darkMode ? "white" : "black",
                    transform: "translate(-50%,-50%)",
                }}
            >
                {countDown > 0 ? (
                    countDown
                ) : (
                    <FontAwesomeIcon icon="bed" />
                )}
            </div>
            {systemIdleTime !== null && (
                <Typography
                    ml={2}
                    mr={5}
                    style={{
                        display: "inline",
                        paddingTop: 1,
                        minWidth: 45,
                        position: "absolute",
                        bottom: 0,
                        right: 0,
                    }}
                >
                    Idle:
                    {" "}
                    {systemIdleTime}
                </Typography>
            )}
        </>
    );
}
